import { ref } from 'vue';

// Tracks the ticket an agent was viewing right before they hopped to another
// open conversation of the SAME contact (e.g. via the "previous
// conversations" list in the contact sidebar). Mobile-only "back to that
// ticket" shortcut reads this; see MessagesView.vue.
//
// Module-level singleton, not per-component state: the shortcut needs to
// survive MessagesView remounting as the route changes between the two
// tickets, and there's only ever one "ticket I came from" at a time anyway.
const relatedTicketReturn = ref(null); // { contactId, conversationId } | null

export function useRelatedTicketReturn() {
  return relatedTicketReturn;
}
